import { render } from "./detail_lv.vue?vue&type=template&id=53da14fa"
import script from "./detail_lv.vue?vue&type=script&lang=js"
export * from "./detail_lv.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__